/* tslint:disable */
/* eslint-disable */

import React, { FunctionComponent } from 'react';
import { ViewProps } from 'react-native';
import { Svg, GProps, Path } from 'react-native-svg';
import { getIconColor } from './helper';

interface Props extends GProps, ViewProps {
  size?: number;
  color?: string | string[];
}

let LocationO: FunctionComponent<Props> = ({ size, color, ...rest }) => {
  return (
    <Svg viewBox="0 0 1024 1024" width={size} height={size} {...rest}>
      <Path
        d="M512.34304 56.32C700.857344 56.32 853.67808 205.770752 853.67808 390.126592c0 168.199168-100.186112 354.92352-300.55936 560.173056-0.338944 0.34816-0.683008 0.690176-1.031168 1.02912-22.515712 21.912576-58.53184 21.423104-80.444416-1.092608C271.219712 744.292352 171.008 557.58848 171.008 390.126592 171.008 205.770752 323.82976 56.32 512.34304 56.32z m0 56.889344c-157.375488 0-284.44672 124.26752-284.44672 276.917248 0 149.999616 93.45024 324.104192 284.514304 520.43264 190.979072-195.625984 284.378112-369.69984 284.378112-520.43264 0-152.649728-127.070208-276.917248-284.445696-276.917248z m0 455.113728c-78.547968 0-142.22336-63.675392-142.22336-142.22336s63.675392-142.22336 142.22336-142.22336 142.22336 63.675392 142.22336 142.22336-63.675392 142.22336-142.22336 142.22336z m0-56.889344c47.128576 0 85.334016-38.20544 85.334016-85.334016s-38.20544-85.334016-85.334016-85.334016-85.334016 38.20544-85.334016 85.334016 38.20544 85.334016 85.334016 85.334016z"
        fill={getIconColor(color, 0, '#333333')}
      />
    </Svg>
  );
};

LocationO.defaultProps = {
  size: 18,
};

LocationO = React.memo ? React.memo(LocationO) : LocationO;

export default LocationO;
